jQuery( function( $ ) {
	$( document ).ready( function() {

		initJS = ( function() {

			var

				init = function() {
					_initFixedMenu();
					_initDropdownMenu();
					_initMobileMenu();
					_initSearch();
					_initMobileSearch();
					_initVideoSlider();
					_initSmallEffects();
				},

				_initFixedMenu = function() {
					$( window ).scroll(function() {
						var scrollTop = $( window ).scrollTop();
						if ( scrollTop  > $( window ).height() - 200 ) {
							$( '.site-header' ).addClass( 'fixed' );
						} else {
							$( '.site-header' ).removeClass( 'fixed' );
						}
					});
				},

				_initDropdownMenu = function() {
					$( '.site-navigation li.dropdown' ).click( function() {
						var _root = $( this );

						var parentClass = $( this ).attr( 'class' );

						$( '.site-navigation li' ).not( _root ).removeClass( 'active' );
						_root.addClass( 'active' );

						$( '.dropdown-navigation' ).each( function() {
							var dataDropdown = $( this ).attr( 'data-dropdown' );

							if ( _root.data( 'dropdown' ) === dataDropdown ) {
								$( '.dropdown-navigation' ).not( this ).removeClass( 'active' );
								$( this ).toggleClass( 'active' );
							}
						});

						if ( $('.site-navigation li.dropdown' ).hasClass( 'active' ) ) {
							$( 'body' ).addClass( 'dropdown-open' );
						} else {
							$( 'body' ).removeClass( 'dropdown-open' );
						}
					});

					$( '.dropdown-navigation .dnm__menu li' ).click( function() {
						/** function to open submenu in dropdown **/
						var submenuName = $( this ).attr( 'data-submenu' ),
						submenu         = $( this ).parents( '.dropdown-navigation').find( '.dn__right[data-submenu~="' + submenuName + '"]' );

						$( this ).parent().find( 'li' ).not( this ).removeClass( 'current' );
						$( this ).addClass( 'current' );
						$( this ).parents( '.dropdown-navigation' ).find( '.dn__right' ).not( submenu ).removeClass( 'current' );
						$( submenu ).addClass( 'current' );
					});

					$( window ).scroll( function() {
						$( '.dropdown-navigation' ).removeClass( 'active' );
						$( 'body' ).removeClass( 'dropdown-open' );
					});
				},

				_initMobileMenu = function() {
					$( '.mobile-navagition-toggle' ).click( function() {
						$( this ).toggleClass( 'open' );
						$( 'body' ).toggleClass( 'mobile-menu-open' );
						$( '.mobile-navigation' ).toggleClass( 'active' );
					});

					$( '.mobile-navigation .menu > li.dropdown > a' ).click( function( e ) {
						e.preventDefault();
						$( this ).parent().toggleClass( 'active' );
						$( '.mobile-navigation .menu > li > a' ).not( this ).parent().removeClass( 'active' );
						$( '.mobile-navigation .menu > li > a' ).not( this ).parent().toggleClass( 'no-active' ).slideToggle( 200 );
						$( this ).parent().children( '.dropdown-menu' ).slideToggle( 200 );
					});

					$( '.mobile-navigation .menu > li.dropdown > .dropdown-menu > .dropdown > a' ).click( function( e ) {
						e.preventDefault();
						$( this ).parents( '.active' ).toggleClass( 'active--gray' );
						$( this ).parent().toggleClass( 'active' );
						$( '.mobile-navigation .menu > li.dropdown > .dropdown-menu > li > a' ).not( this ).parent().removeClass( 'active' );
						$( '.mobile-navigation .menu > li.dropdown > .dropdown-menu > li > a' ).not( this ).parent().toggleClass( 'no-active' ).slideToggle( 200 );
						$( this ).parent().children( '.dropdown-menu' ).slideToggle( 200 );
					});
				},

				_initSearch = function() {
					$( '.site-search-toggle' ).click( function( e ) {
						if ( ! $( 'body' ).hasClass( 'home' ) ) {
							var scrollTop = $( window ).scrollTop();
							$( '.site-search' ).slideToggle();

							if (scrollTop < $(window).height() - 200) {
								if (!$('.site-header').hasClass('fixed')) {
									$( '.site-header' ).addClass( 'fixed' );
								} else {
									$( '.site-header' ).removeClass( 'fixed' );
								}
							} else {
								$( 'html,body' ).animate({
									scrollTop: 0
								}, 300).promise().then(function() {
									setTimeout(function() {
										$( '.site-header' ).addClass( 'fixed' );
									}, 50)
								});



								// if (!$('.site-header').hasClass('fixed')) {
								// 	$( '.site-header' ).addClass( 'fixed' );
								// }
							}

							// if (!$('.site-header').hasClass('fixed')) {
							// 	$( '.site-header' ).addClass( 'fixed' );
							// }
							// if ( scrollTop  < $( window ).height() - 200 ) {
							// 	$( '.site-header' ).addClass( 'fixed' );
							// } else {
							// 	$( '.site-header' ).removeClass( 'fixed' );
							// }
							// $('.site-header').toggleClass('fixed');


						}
					} );
				},

				_initMobileSearch = function() {
					$( '.mobile-search-toggle' ).click( function() {
						$( 'body' ).addClass( 'search-mobile-active' );
						$( '.mobile-search' ).addClass( 'active' );
						$( '.mobile-navigation' ).removeClass( 'active' );
						$( '.mobile-navagition-toggle' ).removeClass( 'open' );
					});

					$( '.mobile-search .mb__close' ).click( function() {
						$( 'body' ).removeClass( 'search-mobile-active' );
						$( '.mobile-search' ).removeClass( 'active' );
					});
				},

				_initVideoSlider = function() {

				},

				_initSmallEffects = function() {
					$( '.site-tools .scroll-to-search' ).click( function() {
						$( 'html, body' ).animate({
						    scrollTop: $( '.site-search' ).offset().top - 76
						}, 1000 );
					});
				}

				finalize = function() {

				}
			;

			return {
				init: init,
				finalize: finalize
			};

		}() );

	});
});
